module.exports = __webpack_public_path__ + "static/media/premierOneCentralSeatMobile.d44493e6.svg";